import { Box } from '@mui/system';
import { GridRenderCellParams } from '@mui/x-data-grid';
import React from 'react';
import { AccessKeyStatus } from 'types/accessKeys';
import AccessKeyStatusChip from '../Chip/AccessKeyStatusChip';

const AccessKeyStatusCell: React.FC<GridRenderCellParams<string>> = ({
	value,
	row
}) => (
	<Box display="flex" flexGrow={1}>
		<AccessKeyStatusChip
			status={value as AccessKeyStatus}
			expireTime={row.expireTime}
		/>
	</Box>
);

export default AccessKeyStatusCell;
